import React from "react";
import Spinner from "../../../Components/spinner";
import CustomPagination from "../../../helper/Pagination";
import {
 ActionButton,
 checkImage,
 ToggleSwitch,
} from "../../../helper/ImageFormat";
import { useNavigate } from "react-router-dom";
import dateformate from "../../../helper/DateFormate";
const CollectionTable = ({
 loading,
 data,
 currentPage,
 perPage,
 handleEditClick,
 handleDelete,
 handleStatusToggle,
 totalCount,
 totalPages,
 handlePageClick,
}) => {
 const navigator = useNavigate();
 const Tableheader = [
  "Name",
  "Image",
  "Product",
  "Catalogue",
  "Updated At",
  "Is Active",
  "Action",
 ];
 return (
  <div className="row">
   <div className="col-md-12 grid-margin stretch-card">
    <div className="card">
     <div className="card-body">
      <div className="table-responsive">
       <table className="custom-table table table-striped">
        <thead>
         <tr>
          <th className="font-weight-bold ">Sort Order</th>
          {Tableheader.map((item, index) => (
           <th className="font-weight-bold " key={index}>
            {item}
           </th>
          ))}
         </tr>
        </thead>
        <tbody>
         {loading ? (
          <tr>
           <td colSpan="8" className="text-center">
            <Spinner />
           </td>
          </tr>
         ) : data.length > 0 ? (
          data.map((item, index) => (
           <tr key={index}>
            <td>{item.position}</td>
            <td>{item.name}</td>
            <td>{checkImage(item.image)}</td>
            <td>
             <button
              type="button"
              className="count-button1"
              onClick={() =>
               navigator(`/product-collection/${item?.id}`, { state: item })
              }
             >
              {item?.productCount}
             </button>
            </td>

            <td>
             <button
              type="button"
              className="count-button1"
              onClick={() =>
               navigator(`/catalogue-collection/${item?.id}`, { state: item })
              }
             >
              {item?.catalogueCount}
             </button>
            </td>
            <td>{dateformate(item.updatedAt)}</td>
            {/* <td>{dateformate(item.createdAt)}</td> */}

            <td>
             <ToggleSwitch
              data={item}
              name="isActive"
              checked={item.isActive}
              handleStatusToggle={handleStatusToggle}
              module={"Collection"}
             />
            </td>
            <td>
             <ActionButton
              data={item}
              handleEditClick={handleEditClick}
              handleDelete={handleDelete}
              module={"Collection"}
             />
            </td>
           </tr>
          ))
         ) : (
          <tr>
           <td colSpan="8" className="text-center">
            <h4>No data available</h4>
           </td>
          </tr>
         )}
        </tbody>
       </table>
      </div>

      {data?.length > 0 && (
       <CustomPagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageClick}
        perPage={perPage}
        totalCount={totalCount}
       />
      )}
     </div>
    </div>
   </div>
  </div>
 );
};

export default CollectionTable;
